import React from "react";
import { Dropdown, Tooltip } from "antd";
import { MoreOutlined, DeleteOutlined } from "@ant-design/icons";

import DropdownMenu from "./DropdownMenu";

// ============================================================================
// CHANGE 1: Added onOpenAdminNote prop to component parameters
// ============================================================================
// This prop is the handler function that opens the Admin Note modal
// It will be passed down to DropdownMenu so the "Admin Note" menu item works
// ============================================================================
function ActionBtns({
  id,
  onSetModal,
  old,
  onDeleteLocal,
  isAdminOrders,
  providedActions,
  isReturn,
  newStyle,
  onOpenAdminNote,
  onUpdateStatus,  // (orderId, targetStatus) => void
  currentStatus,   // current order status string
}) {
  return old ? (
    <>
      <Tooltip title={!providedActions?.length ? `No further action to perform on order n° ${id}` : ""}>
        <Dropdown
          className={"order-dropdown-button"}
          trigger={["click"]}
          destroyPopupOnHide
          overlay={
            <DropdownMenu
              id={id}
              onSetModal={onSetModal}
              isAdminOrders={isAdminOrders}
              providedItems={providedActions}
              isReturn={isReturn}
              onOpenAdminNote={onOpenAdminNote}
              onUpdateStatus={onUpdateStatus}
              currentStatus={currentStatus}
            />
          }
          placement="bottom"
          arrow
        >
          <MoreOutlined />
        </Dropdown>
      </Tooltip>
    </>
  ) : (
    <DeleteOutlined onClick={() => onDeleteLocal(id)} />
  );
}

export default ActionBtns;
